import React from 'react'
import {connect} from 'react-redux'
import { Field,reduxForm,formValueSelector } from 'redux-form'
import TextField from '@material-ui/core/TextField'
import Button from '@material-ui/core/Button'
import { PHONE_REGEXP } from '../../../util/regExp'
import CountDownButton from '../../../uis/countDownButton'
import {getVerification} from '../reducers/user'

const validate = ({phone,verification,newpassword,comfirmpwd}) => {
    const errors = {}
    if (!phone) {
        errors.phone = '必填'
    } else if (!PHONE_REGEXP.test(phone)) {
        errors.phone = '无效的手机号'
    }
    if (!verification) {
        errors.verification = '必填'
    }
    if (!newpassword) {
        errors.newpassword = '必填'
    } else if (!/^(\w){6,12}$/i.test(newpassword)) {
        errors.newpassword = '密码必须为6-12位的数字，字母或下划线'
    }
    if (!comfirmpwd) {
        errors.comfirmpwd = '必填'
    } else if (newpassword !== comfirmpwd) {
        errors.comfirmpwd = '两次输入密码不一致'
    }
    return errors
}

const renderField = ({input,label,type,meta:{ touched,error }}) => (
    <div>
        <TextField 
            {...input}
            label={label}
            onChange={input.onChange}
            fullWidth={input.name === 'verification' ? false : true}
            type={type}
            margin="normal"                         
            required  
            helperText={touched && error}
            FormHelperTextProps={{style: {color: '#F96487'}}}               
        />
    </div>
)

class ResetForm extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
            countdownButtonDisabled: true
        }
    }
    getVerification() {
        const {dispatch,phoneValue,form} = this.props;
        
        dispatch(getVerification(phoneValue,form))
    }
    onChange = time => {
        return time ? `重新发送${time-1}秒` : ''      
    }
    userPhoneInput(value) {
        if (PHONE_REGEXP.test(value)) {
            this.setState({ countdownButtonDisabled: false })
        } else {
          this.setState({ countdownButtonDisabled: true })
        }
    }
    render() {
        const { handleSubmit,submitting } = this.props
        return (
            <form onSubmit={handleSubmit} className="loginForm">
                <p className="forgot">请填写注册时所填的手机号码</p>
                <Field name="phone" component={renderField} type="text" label="手机号码" onChange={(e)=>this.userPhoneInput(e.target.value)} />
                <div className="form-verification">
                    <Field name="verification" component={renderField} type="text" label="短信验证码" />
                    <CountDownButton 
                        disabled={this.state.countdownButtonDisabled}
                        time={5}
                        text={'获取短信验证码'}
                        onChange={this.onChange.bind(this)}
                        onPress={this.getVerification.bind(this)}
                    />   
                </div> 
                <Field name="newpassword" component={renderField} type="password" label="新密码" />
                <Field name="comfirmpwd" component={renderField} type="password" label="确认新密码" />  
                <div className="user-actions">
                <Button
                    variant="raised"
                    color="primary"
                    style={{background: '#92489f'}}
                    disabled={submitting}
                    type="submit"
                    fullWidth
                >
                    确定
                </Button>
                </div>
            </form>
        )
    }  
}

const selector = formValueSelector('resetForm')
ResetForm = connect(state => {
    return {
        phoneValue: selector(state, 'phone')
    }
})(ResetForm)

export default reduxForm({
    form: 'resetForm',
    validate, 
})(ResetForm)


// WEBPACK FOOTER //
// ./src/pages/sign/components/resetForm.js